import { render, staticRenderFns } from "./projection-live.vue?vue&type=template&id=5f412619&scoped=true"
import script from "./projection-live.vue?vue&type=script&lang=js"
export * from "./projection-live.vue?vue&type=script&lang=js"
import style0 from "./projection-live.vue?vue&type=style&index=0&id=5f412619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f412619",
  null
  
)

export default component.exports